import { ChainId, getRpcUrls } from '@endure/chains';

import { envVariables } from './envVariables';

const baseRpcUrls = getRpcUrls({
  nodeRealApiKey: envVariables.VITE_NODE_REAL_API_KEY ?? '',
  alchemyApiKey: envVariables.VITE_ALCHEMY_API_KEY ?? '',
});

const bittensorTestnetPrivateRpcUrl = envVariables.VITE_BITTENSOR_TESTNET_RPC_URL?.trim();

const bittensorTestnetPublicRpcUrls = [
  'https://bittensor-testnet-public.nodies.app',
  'https://bittensor-testnet-lite-public.nodies.app',
  'https://test.chain.opentensor.ai',
];

const bittensorTestnetRpcUrls = bittensorTestnetPrivateRpcUrl
  ? [bittensorTestnetPrivateRpcUrl]
  : bittensorTestnetPublicRpcUrls;

// Bittensor testnet uses VITE_BITTENSOR_TESTNET_RPC_URL exclusively when set,
// so keyed/private endpoints are not diluted by public fallback probes. When
// unset, the public fallback set uses 3 RPCs across 2 independent operators:
//   - bittensor-testnet-{public,lite-public}.nodies.app: same operator
//     (Nodies LLC), separate Cloudflare subdomains → independent rate-limit
//     buckets. A Nodies-level outage takes both down.
//   - test.chain.opentensor.ai: canonical RPC listed at ethereum-lists/chains,
//     totally separate operator from Nodies.
//
// CORS caveat (verified 2026-05-30): none of the three public endpoints send
// `Access-Control-Allow-Origin` on preflighted requests. Plain `POST` with
// `Content-Type: application/json` is a "simple" CORS request (no preflight)
// so viem's primary RPC calls succeed, but wagmi's rank-by-speed health probe
// triggers a preflight and floods the dev console with CORS errors. Data
// still flows correctly; the noise is informational. Set
// `VITE_BITTENSOR_TESTNET_RPC_URL` to a CORS-friendly private endpoint to
// silence the probes entirely.
//
// Wagmi's fallback transport is configured with `rank: { interval: 60_000 }`
// for this chain (see Web3Wrapper/config.ts) so viem health-checks each
// endpoint once per minute and promotes whichever is faster — failover
// works on slow responses, not just hard errors.
export const rpcUrls = {
  ...baseRpcUrls,
  [ChainId.BITTENSOR_TESTNET]: bittensorTestnetRpcUrls,
};
